const exactPricePattern = /^(-?)(\d+)(?:\.(\d+))?$/;

/**
 * Formats an exact database decimal for customer-facing USD display.
 *
 * The calculation uses strings and BigInt so presentation never introduces
 * JavaScript floating-point arithmetic into authoritative commerce values.
 */
export function formatCustomerUsdPrice(
  value: string | null | undefined,
  currencyCode: string | null | undefined = "USD"
) {
  if (value === null || value === undefined || currencyCode?.trim().toUpperCase() !== "USD") {
    return null;
  }

  const match = exactPricePattern.exec(value.trim());
  if (!match) return null;

  const negative = match[1] === "-";
  const integer = match[2];
  const fraction = match[3] || "";
  const hundredths = BigInt(`${integer}${fraction.padEnd(2, "0").slice(0, 2)}`);
  const shouldRoundUp = (fraction[2] || "0") >= "5";
  const rounded = hundredths + (shouldRoundUp ? BigInt(1) : BigInt(0));
  const roundedText = rounded.toString().padStart(3, "0");
  const whole = roundedText.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const cents = roundedText.slice(-2);
  const sign = negative && rounded !== BigInt(0) ? "-" : "";

  return `${sign}$${whole}.${cents}`;
}
